// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2TKUh","image":"Header_image__Elbyf","name":"Header_name__j84Si","info":"Header_info__1_0VI","infoRow":"Header_infoRow__1SLO_"};